import { render } from "./RoutePanel.vue?vue&type=template&id=22fb4668&scoped=true"
import script from "./RoutePanel.vue?vue&type=script&lang=ts"
export * from "./RoutePanel.vue?vue&type=script&lang=ts"

import "./RoutePanel.vue?vue&type=style&index=0&id=22fb4668&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22fb4668"

export default script